import { InternalForkApi } from "./hosted-test/internal-fork.ts";
import { InternalBundleApi } from "./runtime/internal-bundle.ts";
import { CompilerBenchmarkApi } from "./runtime/compiler-benchmark.ts";
import { RunDispatchApi } from "./runtime/run-dispatch.ts";
import { ChatApi } from "./chat/api.ts";
import { McpApi } from "./mcp/api.ts";
import { HostedTestApi } from "./hosted-test/api.ts";
import { CanonicalTestApi } from "./hosted-test/canonical-api.ts";
import { WorkspaceApi } from "./station/workspace-api.ts";
import { Schema } from "effect";
import { HttpApi, HttpApiEndpoint, HttpApiGroup } from "effect/unstable/httpapi";
import { WorkspaceHistoryApi } from "./history/api.ts";
import { StationTagApi } from "./history/tag-api.ts";
import { TraceApi } from "./observability/traces.ts";
import { TraceProbeApi } from "./observability/trace-probe.ts";
import { BrowserObservabilityApi } from "./observability/browser.ts";
import { FlowRecordingsApi } from "./recording/api.ts";
import { ResourceApi } from "./resources/http.ts";
import { GitHubImportApi } from "./station/github.ts";
import { TunnelCanaryApi } from "./mesh/tunnel-canary-api.ts";
import { StationApi } from "./station/api.ts";
import { WorktreeApi } from "./station/worktree-api.ts";
import { DevelopmentApi } from "./development/api.ts";
import { FirstChangeApi } from "./station/first-change.ts";

export const HealthResponse = /* @__PURE__ */ (() => Schema.Struct({ status: Schema.Literal("ok") }))();
export type HealthResponse = typeof HealthResponse.Type;

export class ServiceUnavailable extends Schema.TaggedError<ServiceUnavailable>()(
  "ServiceUnavailable",
  { message: Schema.String, status: Schema.Literal(503) }
) {}

export const WorkerstationApi = HttpApi.make("workerstation").add(
  HttpApiGroup.make("health").add(
    HttpApiEndpoint.get("read", "/api/health", { success: HealthResponse })
  ),
  WorkspaceHistoryApi,
  StationTagApi,
  TraceApi,
  TraceProbeApi,
  BrowserObservabilityApi,
  FlowRecordingsApi,
  ResourceApi,
  GitHubImportApi,
  TunnelCanaryApi,
  StationApi,
  FirstChangeApi,
  DevelopmentApi, WorktreeApi, WorkspaceApi, HostedTestApi, CanonicalTestApi, ChatApi, McpApi, CompilerBenchmarkApi, RunDispatchApi, InternalBundleApi, InternalForkApi
);
